import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LAYOUT_ACTIONS, LayoutActions } from '@core/store/types';
import { PlatformUserAccountService, PlatformUserPresenceService } from '@data/_generated-api/platform-api/services';
import { environment } from '@/environments/environment';

const routesToIgnore = [
  environment.auth.refreshTokenRoute,
  environment.auth.openPlatformRoute,
  environment.auth.authenticationRoute,
  PlatformUserPresenceService.PostUserpresenceActionDesktopmanueelaanmeldenPath,
  PlatformUserPresenceService.PostUserpresenceActionOleaanwezigmeldenPath,
  PlatformUserPresenceService.PostUserpresenceActionOleappopenenPath,
  PlatformUserAccountService.PostUseraccountsActionValidateemailandpasswordPath
];

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  private get areAnyRequestsPending() {
    return this.requests.length > 0;
  }

  constructor(
    @Inject(LAYOUT_ACTIONS)
    public readonly layoutActions: LayoutActions
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    const showLoadingBar = this.areAnyRequestsPending;
    this.layoutActions.toggleLoadingBar(showLoadingBar);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldBeIgnored(req.url)) {
      return next.handle(req);
    }

    this.requests.push(req);

    this.layoutActions.toggleLoadingBar(true);
    return new Observable(observer => {
      const subscription = next.handle(req).subscribe(
        event => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        err => {
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }

  private shouldBeIgnored(url: string) {
    return routesToIgnore.some(r => url.includes(r));
  }
}
